import { jsx as _jsx } from "react/jsx-runtime";
const Imp = () => {
    return (_jsx("span", { className: "imp", children: "*" }));
};
export default Imp;
